const toggle = document.getElementById('header-search-toggle');
const panel = document.getElementById('header-search-panel');
const input = panel?.querySelector('#header-search-field');

if (toggle && panel && input) {
    function isOpen() {
        return toggle.getAttribute('aria-expanded') === 'true';
    }

    function openSearch() {
        panel.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Zavřít vyhledávání');
        input.focus();
    }

    function closeSearch() {
        panel.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Otevřít vyhledávání');
        toggle.focus();
    }

    // Tlačítko
    toggle.addEventListener('click', () => {
        isOpen() ? closeSearch() : openSearch();
    });

    // Escape
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && isOpen()) {
            closeSearch();
        }
    });

    // Klik mimo panel
    document.addEventListener('pointerdown', e => {
        if (isOpen() && !toggle.contains(e.target) && !panel.contains(e.target)) {
            closeSearch();
        }
    });
}
